var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "left" } },
    [
      _c(
        "v-card",
        { staticClass: "mx-auto", attrs: { "max-width": "800" } },
        [
          _c(
            "codemirror",
            _vm._b(
              { attrs: { options: _vm.options }, on: { blur: _vm.handleBlur } },
              "codemirror",
              Object.assign({}, _vm.$props, _vm.$attrs),
              false
            )
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }